import React, { Component } from 'react'
import FormViewer from '../FormViewer'

export default class Task extends Component {
    state = {
        task: [
            { src: '/assets/icons/widgets/clock.svg', name: 'Time', content: '08:00 - 12:00' },
            { src: '/assets/icons/widgets/menuburgur.svg', name: 'Category', content: 'Design' },
            { src: '/assets/icons/widgets/status.svg', name: 'Progress', content: '70%' },
        ],
        taskimg: [
            { img: '/assets/images/task1.jpg' },
            { img: '/assets/images/task3.jpg' },
            { img: '/assets/images/task3.jpg' },
            { img: '/assets/images/task3.jpg' },
            { img: '/assets/images/task2.jpg' },


        ],

    }
    render() {
        return (
            <div className='dashboard-widgets '>
                {/* <div className='task bg-white box-shadow-widgets br-25 w-330 flexcb p-3'>
                    <div className='mrd-2'>
                        <p className='text-smallest mb-2'>Current Task</p>
                        <p className='pld-2 brl-orange fw-700 text-smaller mb-2'>User experience</p>
                        <p className='text-muted text-smallest'>Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat  Velit officia consequat duis enim nostrud amet ...</p>
                    </div>
                    <div>
                        <p className='text-smallest mb-2'>Details</p>
                        <div>
                            {this.state.task.map((prop, index) => {
                                return (
                                    <div className='flexcb nowrap mb-2'>
                                        <div className='flexc mrd-4'>
                                            <img className='mrd-2 w-16' src={prop.src} alt="" />
                                            <p className='color-orange text-smallest'>{prop.name}</p>
                                        </div>
                                        <p className='text-smallest white-space-nowrap'>{prop.content}</p>
                                    </div>
                                )
                            })}
                            <div className='flexcb'>

                                <p className='text-smallest text-muted flexc'>Members:</p>

                                <div className='flexc'>
                                    {this.state.taskimg.map((prop, index) => {
                                        return (
                                            <div style={{ marginLeft: -17 }} >
                                                <img className='w-24 br-50' src={prop.img} alt="" style={{ border: '2px solid #fff' }} />
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
                <div className='task w-100 p-3'>
                    <div className='mrd-2 mb-2'>
                        <p className='text-smaller mb-2'>Current Task</p>
                        <p className='pld-2 brl-orange fw-700 text-semibig mb-2'>User experience</p>
                        <p className='text-muted text-small'>Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat  Velit officia consequat duis enim nostrud amet ...</p>
                    </div>
                    <div className='flexss'>
                        <div className=''>
                            <p className='text-small mb-2'>Details</p>
                            {this.state.task.map((prop, index) => {
                                return (
                                    <div key={index} className='flexcb nowrap mb-2'>
                                        <div className='flexc mrd-4'>
                                            <img className='mrd-2 w-16' src={prop.src} alt="" />
                                            <p className='text-smaller color-orange text-smallest'>{prop.name}</p>
                                        </div>
                                        <p className='text-smaller white-space-nowrap'>{prop.content}</p>
                                    </div>
                                )
                            })}
                        </div>

                        <div className=''>
                            <p className='text-small flexc'>Members:</p>
                            <div className='flexc'>
                                {this.state.taskimg.map((prop, index) => {
                                    return (
                                        <div key={index} className='w-35' style={{ marginLeft: -17 }} >
                                            <img className='w-100 br-50' src={prop.img} alt="" style={{ border: '2px solid #fff' }} />
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
